/**
 * @file   src\components\OrderAddPackage.tsx
 * @brief  OrderAddPackage component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from 'react';
import { Button,Modal,useEffect,useState } from '../utils/thirdpartyComponents';
import Packageicon from '../assets/images/package.svg';
import axios from '../config/axiosConfig';
import {  OrderHardwareApi } from '../utils/apiUrls';
import SmallLoader from './SmallLoader';

interface OrderAddPackageProps {
  onPackageAdd: (id:any) => void; // Callback function to notify when the package is added
  cartData:any
}

const OrderAddPackage: React.FC<OrderAddPackageProps> = ({ cartData,onPackageAdd }) => {
  const [packageList,setPackageList] = useState<any>([]);
  const [selectedPackage, setSelectedPackage] = useState<any>(cartData.packageItems); // State to track the selected package
  const [showModal, setShowModal] = useState(false); // State for showing the confirmation modal
  const [loading, setLoading] = useState(false);
  // const handleAddToCart = (id:number) => {
  //   // Trigger the parent function to set the package as added
  //   onPackageAdd();
  // };

  useEffect(()=>{
    getPackageList()
},[])

    // Function to fetch hardware list
    const getPackageList = async () => {
      try {
        setLoading(true); // Show loader
          // const param1 = `${param.id}`;
          const { data } = await axios.get(OrderHardwareApi.CARWASH_OWNER_LIST_PACKAGE);
          setPackageList(data.data)
 
      } catch (error: any) {
          console.error('Error fetching company information:', error.message);
          throw new Error(error.response?.data?.message || error.message);
      }
      finally{
        setLoading(false);
      }
  };


  // Handle selecting a package
  const handleAddToCart = (id: number) => {
    const selected = packageList.find((pkg: any) => pkg.packageId === id);
    setSelectedPackage(selected);
    onPackageAdd(selected); // Notify parent about the selected package
  };

  // Trigger modal to confirm removal of the current package
  const handleRemovePackage = () => {
    setShowModal(true); // Show modal to confirm removal
  };

  // Confirm removal of the selected package
  const handleConfirmRemove = () => {
    setSelectedPackage(null); // Remove the selected package
    onPackageAdd(0); // Notify parent about the package removal
    setShowModal(false); // Close the modal
  };

  return (
    <div className="device-listing-wrap package-listing-wrap d-flex justify-content-center scroll-custom">
         {packageList.map((packageitem:any) => (
      <div className="product-card text-center" key={packageitem.packageId}>
        <div className={`device-frame ${packageitem.packageImage ? 'device-img' : ''} d-flex align-items-center justify-content-center`}>
          {/* <img src={Packageicon} alt="Marketing Package" /> */}
          <img src={packageitem.packageImage ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH || ""}${packageitem.packageImage}` : Packageicon} alt="Marketing Package" />

        </div>
        <h5 className="f-bold">{packageitem.packageName}</h5>
        <h2 className="f-bold">${packageitem.packagePrice}</h2>
        <p className="f-medium">
          {packageitem.packageDesc}
        </p>
        {selectedPackage?.packageId === packageitem.packageId ? (
            <Button variant="danger" className="primary-btn" onClick={handleRemovePackage} title='Remove Package'>
              Remove Package
            </Button>
          ) : (
            <Button
              variant="primary"
              className="primary-btn"
              onClick={() => handleAddToCart(packageitem.packageId)}
              disabled={!!selectedPackage} // Disable if a package is already selected
              title='Add To Cart'
            >
              Add To Cart
            </Button>
          )}
      </div>
             ))}

              {/* Confirmation Modal */}
              <Modal
                    show={showModal} onHide={() => setShowModal(false)} centered className='add-modal'
                >
                    <Modal.Body className='text-center'>
                        <h5 className='f-bold text-center'>Are you sure you want to remove the current package ?</h5>
                        <div className="btn-sec d-grid">
                            <Button variant="light" className="secondary-btn"  onClick={() => setShowModal(false)}>Cancel</Button>
                            <Button variant="primary" className='primary-btn btn-main m-0' onClick={handleConfirmRemove}>Yes</Button>
                        </div>
                    </Modal.Body>
                </Modal>
                {loading && <SmallLoader />}
    </div>
  );
};

export default OrderAddPackage;
